module.exports = __webpack_public_path__ + "img/close_color.45100d18.svg";